<template>
  <div class="notification" style="padding: 16px; margin-bottom: 24px;">
    <p>{{ $t('dashboard.new_season_hint') }}</p>
  </div>
</template>

<script>
export default {
  name: 'FutureScheduleHint',
  components: {},
  data () {
    return {}
  },
  beforeCreate () {
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {
  }
}
</script>

<style lang="scss">

</style>
